export const parseCircleMarkdown = (raw: string): string[] => {
  return raw
    .split(/\r?\n/)
    .map((line) => line.trim().replace(/^@/, ''))
    .filter((line) => /^[a-zA-Z0-9_]{1,50}$/.test(line))
    .filter((v, i, arr) => arr.indexOf(v) === i);
};
